/**
 * Helper utility to manually manage profile index for testing and debugging
 * SECURITY: Uses encrypted secure storage instead of plain localStorage
 */
import { secureStorage } from './security';

export const addTestProfileToIndex = (walletAddress, profileData) => {
  try {
    const storageKey = 'znoospace_user_profiles';
    const existingProfiles = secureStorage.getItem(storageKey) || {};
    
    // Add the test profile
    existingProfiles[walletAddress] = {
      ...profileData,
      walletAddress,
      status: 'completed',
      lastUpdated: new Date().toISOString(),
      source: 'manual_test' // Mark as test data
    };
    
    secureStorage.setItem(storageKey, existingProfiles);
    console.log('✅ Added test profile to index:', profileData.displayName || profileData.username);
    return true;
  } catch (error) {
    console.error('❌ Failed to add test profile:', error);
    return false;
  }
};

export const getProfileFromIndex = (walletAddress) => {
  try {
    const storageKey = 'znoospace_user_profiles';
    const profiles = secureStorage.getItem(storageKey) || {};
    return profiles[walletAddress] || null;
  } catch (error) {
    console.error('❌ Failed to get profile from index:', error);
    return null;
  }
};

export const listAllProfilesInIndex = () => {
  try {
    const storageKey = 'znoospace_user_profiles';
    const profiles = secureStorage.getItem(storageKey) || {};
    console.log('📋 All profiles in index:', profiles);
    return profiles;
  } catch (error) {
    console.error('❌ Failed to list profiles:', error);
    return {};
  }
};

// Add a test profile for the current wallet
export const addCurrentWalletTestProfile = () => {
  const walletAddress = '9r3aFfNuu8pqG3jEkjDNhpm6BW7p87Qe2XHKaCUkRCip';
  const testProfile = {
    displayName: 'User 9r3aFfNu',
    username: 'user_9r3affnu',
    bio: 'Test profile for persistence debugging',
    avatarUrl: '',
    txId: 'test_transaction_id_123'
  };
  
  return addTestProfileToIndex(walletAddress, testProfile);
};
